<template>
  <div class="container">
    <h3 class="title">Jaka pomoc jest potrzebna?</h3>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('wpie')">Wizyta pielęgniarki</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('leki')">Dostawa leków</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('tran')">Transport med.</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('hosp')">Hospitalizacja</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('tele')">Teleserwis</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('inne')">Inne</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "StepMedicalOther",
  methods: {
    ...mapMutations(['setUserData', 'setAssistanceStep', 'setStep']),
    btnHandler (ServiceType) {
      this.setUserData({ ServiceType })
      this.setAssistanceStep('additional')
      this.setStep({ index: 3, step: { text: 'Dodatkowe uwagi', value: 'additional' }})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepMedicalOther.vue